import { ComplectationOptionsList } from '@/types/complectation.type.ts';

export const complectationOptions: ComplectationOptionsList = {
    abs: {
        name: 'Антиблокировочная система тормозов (ABS)',
        values: {
            yes: 'Да',
        },
    },
    all_round_camera: {
        name: 'Камера кругового обзора',
        values: {
            yes: 'Да',
        },
    },
    auto_parking_system: {
        name: 'Система автоматической парковки',
        values: {
            yes: 'Да',
        },
    },
    aux: {
        name: 'AUX',
        values: {
            yes: 'Да',
        },
    },
    blind_spot_monitoring: {
        name: 'Система мониторинга слепых зон',
        values: {
            yes: 'Да',
        },
    },
    bluetooth: {
        name: 'Bluetooth',
        values: {
            yes: 'Да',
        },
    },
    central_locking: {
        name: 'Центральный замок',
        values: {
            yes: 'Да',
        },
    },
    climate: {
        name: 'Климат-контроль',
        values: {
            zone_1: '1 зона',
            zone_2: '2 зоны',
            zone_3: '3 зоны',
        },
    },
    collision_avoidance_system: {
        name: 'Система предотвращения столкновений',
        values: {
            yes: 'Да',
        },
    },
    combination_skin: {
        name: 'Комбинация натуральной и искусственной кожи в отделке сидений',
        values: {
            yes: 'Да',
        },
    },
    conditioner: {
        name: 'Кондиционер',
        values: {
            yes: 'Да',
        },
    },
    cruise_control: {
        name: 'Круиз-контроль',
        values: {
            yes: 'Да',
        },
    },
    driver_knee_airbag: {
        name: 'Коленная подушка безопасности водителя',
        values: {
            yes: 'Да',
        },
    },
    driver_tracking_system: {
        name: 'Система слежения за состоянием водителя',
        values: {
            yes: 'Да',
        },
    },
    ebd: {
        name: 'Система распределения тормозных усилий (EBD)',
        values: {
            yes: 'Да',
        },
    },
    electric_driver_seat: {
        name: 'Электрорегулировка сиденья водителя',
        values: {
            yes: 'Да',
        },
    },
    electric_passenger_seat: {
        name: 'Электрорегулировка сиденья пассажира',
        values: {
            yes: 'Да',
        },
    },
    emergency_brake_assist: {
        name: 'Система помощи при экстренном торможении',
        values: {
            yes: 'Да',
        },
    },
    fog_lights: {
        name: 'Противотуманные фары',
        values: {
            yes: 'Да',
        },
    },
    front_airbags: {
        name: 'Фронтальные подушки безопасности водителя и переднего пассажира',
        values: {
            yes: 'Да',
        },
    },
    front_parking_sensors: {
        name: 'Датчики парковки спереди',
        values: {
            yes: 'Да',
        },
    },
    glonass: {
        name: 'Устройство вызова экстренных оперативных служба Эра-Глонасс',
        values: {
            yes: 'Да',
        },
    },
    hac: {
        name: 'Система помощи при старте в горку (HAC)',
        values: {
            yes: 'Да',
        },
    },
    headlight_washer: {
        name: 'Омыватель фар',
        values: {
            yes: 'Да',
        },
    },
    headlights: {
        name: 'Фары',
        values: {
            halogen: 'Галогеновые',
            led: 'Светодиодные',
            xenon: 'Ксеноновые/Биксеноновые',
        },
    },
    heated_seats: {
        name: 'Подогрев сидений',
        values: {
            yes: 'Да',
        },
    },
    heated_wheel: {
        name: 'Подогрев руля',
        values: {
            yes: 'Да',
        },
    },
    hold_lane_assist: {
        name: 'Ассистент удержания автомобиля в полосе движения',
        values: {
            yes: 'Да',
        },
    },
    immobilizer: {
        name: 'Иммобилайзер',
        values: {
            yes: 'Да',
        },
    },
    interiortype: {
        name: 'Салон',
        values: {
            cloth: 'Ткань',
            leather: 'Кожа',
        },
    },
    isofix: {
        name: 'Крепления для детского кресла ISOFIX',
        values: {
            yes: 'Да',
        },
    },
    leather_gearshift: {
        name: 'Отделка кожей рычага КПП',
        values: {
            yes: 'Да',
        },
    },
    leather_wheel: {
        name: 'Отделка кожей рулевого колеса',
        values: {
            yes: 'Да',
        },
    },
    light_sensor: {
        name: 'Датчик света',
        values: {
            yes: 'Да',
        },
    },
    memory_settings: {
        name: 'Память настроек для двух водителей (сиденье, наружные зеркала)',
        values: {
            yes: 'Да',
        },
    },
    multifunction_steering_wheel: {
        name: 'Мультифункциональное рулевое колесо',
        values: {
            yes: 'Да',
        },
    },
    native_navigation_system: {
        name: 'Штатная навигационная система',
        values: {
            yes: 'Да',
        },
    },
    number_seats: {
        name: 'Количество мест',
        values: {
            seats_5: '5',
            seats_7: '7',
            seats_8: '8',
        },
    },
    panoramic_roof: {
        name: 'Панорамная крыша',
        values: {
            yes: 'Да',
        },
    },
    part_folding_baskrest: {
        name: 'Складывающаяся по частям спинка заднего сиденья 60:40',
        values: {
            yes: 'Да',
        },
    },
    power_heated_mirrors: {
        name: 'Зеркала с электроприводом и обогревом',
        values: {
            yes: 'Да',
        },
    },
    power_tailgate: {
        name: 'Электропривод двери багажника',
        values: {
            yes: 'Да',
        },
    },
    power_windows: {
        name: 'Электростеклоподъемники (передние и задние)',
        values: {
            yes: 'Да',
        },
    },
    rain_sensor: {
        name: 'Датчик дождя',
        values: {
            yes: 'Да',
        },
    },
    rear_door_lock: {
        name: 'Блокировка задних дверей',
        values: {
            yes: 'Да',
        },
    },
    rear_parking_sensors: {
        name: 'Датчики парковки сзади',
        values: {
            yes: 'Да',
        },
    },
    rear_view_camera: {
        name: 'Камера заднего вида',
        values: {
            yes: 'Да',
        },
    },
    roof_rails: {
        name: 'Рейлинги на крыше',
        values: {
            yes: 'Да',
        },
    },
    running_lights: {
        name: 'Дневные ходовые огни',
        values: {
            yes: 'Да',
        },
    },
    safety_shutters: {
        name: 'Шторки безопасности',
        values: {
            yes: 'Да',
        },
    },
    seat_ventilation: {
        name: 'Вентиляция сидений',
        values: {
            yes: 'Да',
        },
    },
    side_airbags: {
        name: 'Боковые подушки безопасности',
        values: {
            yes: 'Да',
        },
    },
    signalling: {
        name: 'Сигнализация',
        values: {
            yes: 'Да',
        },
    },
    smart_key: {
        name: 'Система "Smart key" — доступ без ключа + кнопка START/STOP',
        values: {
            yes: 'Да',
        },
    },
    socket_12v: {
        name: 'Розетка 12V',
        values: {
            yes: 'Да',
        },
    },
    socket_220v: {
        name: 'Розетка ~220V',
        values: {
            yes: 'Да',
        },
    },
    steering_wheel: {
        name: 'Регулировка руля',
        values: {
            by_height: 'по высоте',
            by_height_reach: 'по высоте и вылету',
        },
    },
    tcs: {
        name: 'Антипробуксовочная система (TCS)',
        values: {
            yes: 'Да',
        },
    },
    tire_pressure_monitoring: {
        name: 'Система мониторинга давления в шинах',
        values: {
            yes: 'Да',
        },
    },
    usb: {
        name: 'USB',
        values: {
            yes: 'Да',
        },
    },
    wheels_material: {
        name: 'Материал дисков',
        values: {
            alloy: 'Легкосплавные',
            steel: 'Стальные',
        },
    },
    wheels_size: {
        name: 'Размер дисков',
        values: {
            wheels_size_15: 'Диски 15"',
            wheels_size_16: 'Диски 16"',
            wheels_size_17: 'Диски 17"',
            wheels_size_18: 'Диски 18"',
            wheels_size_19: 'Диски 19"',
            wheels_size_20: 'Диски 20"',
            wheels_size_21: 'Диски 21"',
            wheels_size_22: 'Диски 22"',
        },
    },
};
